import { render, staticRenderFns } from "./shopCategoryDialog.vue?vue&type=template&id=353af87e&scoped=true"
import script from "./shopCategoryDialog.vue?vue&type=script&lang=js"
export * from "./shopCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./shopCategoryDialog.vue?vue&type=style&index=0&id=353af87e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353af87e",
  null
  
)

export default component.exports